"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeInfo = exports.getTheme = void 0;
var BackofficeLight = __importStar(require("./BackofficeLight"));
var BackofficeDark = __importStar(require("./BackofficeDark"));
var MMTLight = __importStar(require("./MMTLight"));
var VendorLight = __importStar(require("./VendorLight"));
var themes = {
  BackofficeLight: BackofficeLight,
  BackofficeDark: BackofficeDark,
  MMTLight: MMTLight,
  VendorLight: VendorLight
};
var getTheme = function getTheme(themeName) {
  var theme = themes[themeName];
  if (!theme) {
    console.error("Error: theme \"".concat(themeName, "\" does not exist"));
  }
  return theme;
};
exports.getTheme = getTheme;
exports.themeInfo = {
  Backoffice: {
    light: 'BackofficeLight',
    dark: 'BackofficeDark'
  },
  MMT: {
    light: 'MMTLight'
  },
  Vendor: {
    light: 'VendorLight'
  }
};